module.exports = __webpack_public_path__ + "img/inda_logo.780c5e57.png";